import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface HttpInterface {
  get<T>(url: string): Observable<T>;
  getBlob(url: string): Observable<Blob>;
  post<T>(url: string, body: unknown): Observable<T>;
  postForm<T>(url: string, body: FormData): Observable<T>;
}
export const HTTP_SERVICE = new InjectionToken<HttpInterface>('lucky draw http service');
